module.exports = __webpack_public_path__ + "7af253d6fabfe0c15202371f9e461584.png";